import { Close } from '@mui/icons-material';
import { Stack, IconButton } from '@mui/material';
import type { ReactNode } from 'react';

import {
  SwipeableDialog,
  SwipeableDialogClose,
  SwipeableDialogContent,
  SwipeableDialogModal,
  SwipeableDialogTitle,
} from '@woovi/ui';

type PluginSwipeableDialogProps = {
  children: ReactNode;
  title: ReactNode;
  isOpen: boolean;
  onOpenChange: () => void;
};

const PluginSwipeableDialog = ({
  title,
  children,
  onOpenChange,
  isOpen,
}: PluginSwipeableDialogProps): ReactNode => {
  return (
    <SwipeableDialog isOpen={isOpen} onOpenChange={onOpenChange}>
      <SwipeableDialogModal
        sx={{
          '@media (min-width: 600px)': {
            width: '480px',
            minWidth: '480px',
            maxWidth: 'fit-content',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          },
        }}
      >
        <SwipeableDialogTitle sx={{ p: 1, pl: 2 }}>
          <Stack
            direction='row'
            justifyContent='space-between'
            alignItems='center'
          >
            {title}
            <SwipeableDialogClose>
              <IconButton
                size='small'
                sx={(theme) => ({
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.text.primary,
                  },
                })}
              >
                <Close />
              </IconButton>
            </SwipeableDialogClose>
          </Stack>
        </SwipeableDialogTitle>
        <SwipeableDialogContent
          sx={{
            maxWidth: '100%',
            height: '80vh',
            maxHeight: '80vh',
            '@media (min-width: 600px)': {
              width: '480px',
              minWidth: '480px',
            },
          }}
        >
          {children}
        </SwipeableDialogContent>
      </SwipeableDialogModal>
    </SwipeableDialog>
  );
};

export default PluginSwipeableDialog;
